export const EasiestQuiz = [
  {
    type: "multiple",
    question: "Which type of site has no electrical or water hookup?",
    correctAnswer: "Unserviced",
    options: [
      "All sites have electrical and water hookup",
      "Regular Serviced",
      "50 Amp",
      "Unserviced",
    ],
  },
  {
    type: "multiple",
    question:
      "This type of site fits camper trucks/vans, small trailers (22' and under), motorhomes (25' and under), or tenters wanting electricity.",
    correctAnswer: "Regular Serviced",
    options: ["Regular Serviced", "50 Amp", "Unserviced", "Premium Serviced"],
  },
  {
    type: "multiple",
    question:
      "This type of site is for trailers larger than 22' or motorhomes above 25'.",
    correctAnswer: "Premium Serviced",
    options: ["Premium Serviced", "Regular Serviced", "50 Amp", "Unserviced"],
  },
  {
    type: "multiple",
    question:
      "We only have 5 of these campsites. They are for trailers (usually very large ones) that want extra power.",
    correctAnswer: "50 Amp",
    options: ["Premium Serviced", "Regular Serviced", "50 Amp", "Unserviced"],
  },
  {
    type: "multiple",
    question: "Do we allow dogs in our cabins?",
    correctAnswer:
      "Dogs are allowed in all cabins, except for the waterfront cabin.",
    options: [
      "No",
      "Yes",
      "Dogs are allowed in all cabins, except for cabins I, J, and K.",
      "Dogs are allowed in all cabins, except for the waterfront cabin.",
    ],
  },
  {
    type: "multiple",
    question: "What days do we offer pumpouts on?",
    correctAnswer: "Mondays, Wednesdays, and Fridays",
    options: [
      "Mondays, Wednesdays, and Fridays",
      "Tuesdays, Thursdays, and Saturdays",
      "Mondays, Thursdays, and Sundays",
      "Wednesdays, Fridays, and Sundays",
    ],
  },
  {
    type: "multiple",
    question: "How much does a pumpout cost? (tax is included)",
    correctAnswer: "$25",
    options: ["$25", "$20", "$15", "$30", "$10"],
  },
  {
    type: "multiple",
    question: "Do we have sewage hookup on our sites?",
    correctAnswer: "No, we only have electrical and water hookup",
    options: ["Yes", "No, we only have electrical and water hookup"],
  },
];
